import { ActionData } from "./action-data";

export class MepActionButton {
    public text: string;
    public role?: string;
    public data?: ActionData;
}